module.exports = __webpack_public_path__ + "static/Anitian-0c0629062ec668b7d98038ff2ee438e4.jpg";